import React from 'react'
import './PropertyRentCompT4.scss'
import PropTypes from 'prop-types'
import {
  PropertyImage,
  UnitMix,
  PropertyInfo,
  DonutChartT2,
  AmenitiesT1
} from '@components/custom'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import { PageTitleBar } from '@components/common'

export class PropertyRentCompT4 extends React.Component {

  editPropertyData = t => {
    const { propertyData } = this.props.propertyInfoData
    this.props.editFeature({ ...propertyData, ...t })
  }

  render() {
    const {
      propertyType,
      templateDataLimits: { unitMixCount, amenitiesCount },
      toggleSettings,
      templateName,
      themeColors,
      propertyNameList,
      donutChartThemeColors,
      compsWithSubjectProperty
    } = this.props
    const {
      propertyData,
      comparableData,
      chartData,
      signedUrl,
      hideUnitMixTotal,
      unitMixDisclaimerData
    } = this.props.propertyInfoData
    const { hasBranding, hasPageTitle, hasAmenities, hasDonut } = toggleSettings
    // const comparableDataT4 = [...comparableData]
    const AmenitiesT4Data = [...propertyData.amenities]
    const { showDisclaimer, disclaimerText } = propertyData
    const pageTitleBar = (!hasBranding && !hasPageTitle) ? null : (
      <div className="title">
        <PageTitleBar templateName={templateName} hasPageTitle={hasPageTitle} hasBranding={hasBranding} themeColors={themeColors} />
      </div>
    )

    // if (comparableDataT4.length > unitMixCount) {
    //   const comparableDataTotal = comparableDataT4.pop()
    //   comparableDataT4.splice(unitMixCount)
    //   comparableDataT4.push(comparableDataTotal)
    // }

    return (
      <div
        className={(!hasBranding && !hasPageTitle) ? 'no-margin-main' : 'main' }
        data-testid={`property-rent-comps-T4-${propertyType}`} id={`#property_${propertyType}`}>
        {propertyType.toString().includes('S') && pageTitleBar}
        {(!compsWithSubjectProperty && (Number(propertyType) % 2 === 1)) && pageTitleBar}
        {(compsWithSubjectProperty && Number(propertyType) % 2 === 0) && pageTitleBar}

        <div className="property-container-t4">
          <div className="property-image-plus-info">
            <PropertyImage
              propertyType={propertyType}
              imageUrl={signedUrl || ''}
              templateName={templateName}
            />
            <div className="info">
              <PropertyInfo
                propertyInfo={propertyData}
                propertyType={propertyType}
                templateName={templateName}
                propertyNameList={propertyNameList}
              />
            </div>
          </div>
          <div className="unit-mix-table">
            <UnitMix comparableData={comparableData} unitMixCount={unitMixCount} propertyType={propertyType} hideUnitMixTotal={hideUnitMixTotal} unitMixDisclaimerData={unitMixDisclaimerData}/>
          </div>
          {hasDonut && (
            <div className="donut-chart">
              <DonutChartT2
                chartData={chartData}
                donutChartThemeColors={donutChartThemeColors}
                noHeader={true}
                propertyType={propertyType}
                themeColors={themeColors}
              />
            </div>
          )}
          {hasAmenities && (
            <AmenitiesT1
              templateName={templateName}
              amenities={AmenitiesT4Data}
              amenitiesCount={amenitiesCount}
              editPropertyData={this.editPropertyData}
              propertyType={propertyType}
              themeColors={themeColors}
              disclaimerText={disclaimerText}
              showDisclaimer={showDisclaimer}
            />
          )}
        </div>
        {propertyType.toString().includes('S') && (
          <>
            <div className="vertical-divider"></div>
            <hr className="page-divider" />
          </>
        )}
        {(!compsWithSubjectProperty && Number(propertyType) % 2 === 1) && (
          <>
            <div className="vertical-divider" ></div>
            <hr className="page-divider" />
          </>
        )}
        {(compsWithSubjectProperty && Number(propertyType) % 2 === 0) && (
          <>
            <div className="vertical-divider"></div>
            <hr className="page-divider" />
          </>
        )}
      </div>
    )
  }
}

PropertyRentCompT4.propTypes = {
  donutChartThemeColors: PropTypes.object,
  amenitiesCount: PropTypes.number,
  editFeature: PropTypes.func,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasSourceNotes: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasPageTitle: PropTypes.bool,
    hasAmenities: PropTypes.bool,
    hasDonut: PropTypes.bool
  }),
  templateName: PropTypes.string,
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  propertyInfoData: PropTypes.shape({
    propertyData: PropTypes.object,
    comparableData: PropTypes.arrayOf(
      PropTypes.object
    ),
    chartData: PropTypes.shape({
      '1 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 1 Bath': PropTypes.number,
      '2 Bedroom / 2 Bath': PropTypes.number,
      '3 Bedroom / 3 Bath': PropTypes.number
    }),
    signedUrl: PropTypes.string,
    hideUnitMixTotal: PropTypes.bool,
    unitMixDisclaimerData: PropTypes.object
  }),
  templateDataLimits: PropTypes.shape({
    unitMixCount: PropTypes.number,
    amenitiesCount: PropTypes.number
  }),
  propertyNameList: PropTypes.array,
  themeColors: PropTypes.object,
  compsWithSubjectProperty: PropTypes.bool
}

const mapStateToProps = state => ({
  templateDataLimits: Comps.selectors.comps.templateDataLimits(state),
  templateName: Comps.selectors.comps.templateName(state),
  themeColors: Comps.selectors.comps.themeColors(state),
  compsWithSubjectProperty: Comps.selectors.comps.compsWithSubjectProperty(state)
})

export default connect(mapStateToProps)(PropertyRentCompT4)

